// aqui preciso adicionar as funcionalidades que o plano ativo tem que estão em functions
// preciso mostrar as customizações que o clube tem que estão em customs
// montar as regras dos clubes que vendem e que nao vendem
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Paper,
    Stack,
    Typography,
    TextField,
    ToggleButtonGroup,
    ToggleButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    TablePagination,
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import { Payment, Business, Cancel, CheckCircle, HourglassEmpty, PauseCircle, Report } from '@mui/icons-material';

import React, { useEffect, useMemo, useState, useCallback } from 'react';
import server from '../../../../services/server';
import { useFetch } from '../../../../hooks/useFecth';
import { Link, useParams } from 'react-router-dom';
import useDialog from '../../../../hooks/useDialog';
import { useFormik } from 'formik';
import useErrors from '../../../../hooks/useErrors';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FormControlLabel, Switch } from '@mui/material';
import { DialogSale } from '../../Proposal';
import SelectPlan from '../../../../components/SelectPlan';
import { debounce } from 'lodash';
import { payments } from '../../../../services/helpers';
import { Download, Edit, OpenInNew, Sync } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import { useConfirm } from 'material-ui-confirm';
import { useClub } from '../../../Club/ClubContext';
import { useAuth } from '../../../../context/AuthContext';
import Address from '../../../../components/Address';
import { InvoicesList } from '../../../../components/InvoicesList';
import { DialogInvoices } from './DialogInoices';
import { formatDate } from '../../../Club/components/DialogSubscriber';

const CYCLE_LABELS = {
    WEEKLY: 'Semanal',
    BIWEEKLY: 'Quinzenal',
    MONTHLY: 'Mensal',
    BIMONTHLY: 'Bimestral',
    QUARTERLY: 'Trimestral',
    SEMIANNUALLY: 'Semestral',
    YEARLY: 'Anual',
};

const FUNCTION_OPTIONS = [
    { value: 'cupons', label: 'Rede de descontos' },
    { value: 'vouchers', label: 'Rede local' },
    { value: 'cashback', label: 'Cashback' },
    { value: 'multi_app', label: 'App Seu Clube' },
    { value: 'reseller', label: 'Revenda/Página de vendas' },
    { value: 'benefit', label: 'Gestão de benefícios' },
    { value: 'telepet', label: 'Telepet' },
];

const ADDITIONAL_OPTIONS = [
    { value: 'telemedicina', label: 'Telemedicina' },
    { value: 'telepsicologia', label: 'Telepsicologia' },
    { value: 'seguro', label: 'Seguro de vida' },
    { value: 'telepet', label: 'Telepet' },
];

const CUSTOM_OPTIONS = [
    { value: 'custom_app', label: 'Aplicativo' },
    { value: 'custom_telemedicina', label: 'Telemedicina' },
    { value: 'custom_telepet', label: 'Telepet' },
];

const FUNCTION_LABELS = {
    ...Object.fromEntries(FUNCTION_OPTIONS.map(item => [item.value, item.label])),
    custom_app: 'App Personalizado',
};
const ADDITIONAL_LABELS = Object.fromEntries(ADDITIONAL_OPTIONS.map(item => [item.value, item.label]));
const CUSTOM_LABELS = Object.fromEntries(CUSTOM_OPTIONS.map(item => [item.value, item.label]));

function asList(raw) {
    if (Array.isArray(raw)) return raw.filter(Boolean);
    if (typeof raw === 'string') return raw.split(',').map(item => item.trim()).filter(Boolean);
    return raw ? [raw] : [];
}

function ChipList({ items, labels, empty }) {
    if (!items.length) {
        return <Typography variant="body2" color="text.secondary">{empty}</Typography>;
    }
    return (
        <Stack direction="row" flexWrap="wrap" gap={0.75} useFlexGap>
            {items.map(key => (
                <Chip key={key} label={labels[key] || key} size="small" variant="outlined" />
            ))}
        </Stack>
    );
}

const SIGNATURE_STATUS_META = {
    WAITING: { label: 'Aguardando', color: 'warning', icon: HourglassEmpty },
    ACTIVE: { label: 'Ativa', color: 'success', icon: CheckCircle },
    EXPIRED: { label: 'Vencida', color: 'error', icon: Report },
    CANCELLED: { label: 'Cancelada', color: 'default', icon: Cancel },
    CANCELED: { label: 'Cancelada', color: 'default', icon: Cancel },
    INACTIVE: { label: 'Inativa', color: 'default', icon: PauseCircle },
};

function toPickerDate(value) {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

function toIsoDate(value) {
    if (!value) return '';
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

const statuses = {
    PENDING: { label: 'Pendente', color: 'warning' },
    RECEIVED: { label: 'Recebida', color: 'success' },
    CONFIRMED: { label: 'Confirmada', color: 'success' },
    OVERDUE: { label: 'Atrasada', color: 'error' },
    REFUNDED: { label: 'Estornada', color: 'default' },
    DELETED: { label: 'Removida', color: 'default' },
    CANCELED: { label: 'Cancelada', color: 'default' },
    EXPIRED: { label: 'Expirada', color: 'default' },
    PENDING_REFUND: { label: 'Pendente de Estorno', color: 'default' },
    REFUND_FAILED: { label: 'Estorno Falhou', color: 'default' },
    REFUND_IN_PROGRESS: { label: 'Estorno em Progresso', color: 'default' },
    REFUND_PENDING: { label: 'Estorno Pendente', color: 'default' },
};

function DialogCreateContract({ data, mutate }) {
    const { open, handleClose } = useDialog('#create-contract');
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();

    const { data: plans } = useFetch(`plans`, {
        params: { paged: false },
    });

    const { values, handleSubmit, getFieldProps, setFieldValue, errors, setValues, isSubmitting } = useFormik({
        initialValues: {
            contractType: '',
            startDate: '',
            endDate: '',
            description: '',
            planId: '',
            functions: '',
            plan: ``,
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                // Aqui você pode implementar a lógica para criar o contrato
                await server.post(`subscription/migratedClub`, { clubId, ...values });
                enqueueSnackbar(`Contrato criado com sucesso.`);
                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    // Selected plan details to reflect in inputs when plan changes
    const [selectedPlan, setSelectedPlan] = React.useState(null);

    // Handle plan change: set form field and fetch plan details
    const handlePlanChange = async ({ target: { value } }) => {
        try {
            await setFieldValue('planId', value, false);
            if (!value) {
                setSelectedPlan(null);

                return;
            }
            const { data } = await server.get(`plans/${value}`);
            // API may return either { data: {...} } or raw object; normalize
            const plan = data?.data || data;
            setSelectedPlan(plan || null);

            setValues(prev => ({
                ...prev,
                plan,
                functions: plan?.functions || '',
                planId: plan.id,
            }));
        } catch (error) {
            setErrors(error);
        }
    };

    // const hasCoupons = selectedPlan?.functions?.includes('cupons');
    // const hasVouchers = selectedPlan?.functions?.includes('vouchers');
    // const hasCashback = selectedPlan?.functions?.includes('cashback');
    // const hasMultiApp = selectedPlan?.functions?.includes('multi_app');
    // const hasCustomApp = selectedPlan?.functions?.includes('custom_app');
    // const hasReseller = selectedPlan?.functions?.includes('reseller');
    // const hasBenefit = selectedPlan?.functions?.includes('benefit');

    // const hasTelePsicologia = selectedPlan?.additionals?.includes("telepsicologia");
    // const hasSeguro =  selectedPlan?.additionals?.includes("seguro");
    // const hasTeleMedicina= selectedPlan?.additionals?.includes("telemedicina");

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Criar Novo Contrato</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2} sx={{ mt: 2 }}>
                    <SelectPlan
                        {...getFieldProps('planId')}
                        onChange={handlePlanChange}
                        valueSelected={values.planId}
                        fullWidth
                        error={!!errors.planId}
                        helperText={errors.planId}
                    />
                    {/*
                    {Boolean(selectedPlan) && (
                        <>
                            {values.functions}
                            <ToggleButtonGroup
                                fullWidth
                                onChange={(e, value) => setFieldValue('functions', value)}
                                value={values.functions}
                                name="functions"
                            >
                                <ToggleButton   sx={{ fontSize: 11 }} disabled={!hasCoupons} value="cupons">
                                    Rede de descontos
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasVouchers} value="vouchers">
                                    Rede local
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasCashback} value="cashback">
                                    Cashback
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasMultiApp} value="multi_app">
                                    App Seu Clube
                                </ToggleButton>
                                <ToggleButton   sx={{ fontSize: 11 }} disabled={!hasCustomApp} value="custom_app">
                                    App Personalizado
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasReseller} value="reseller">
                                    Revenda/Página de vendas
                                </ToggleButton>
                                <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasBenefit} value="benefit">
                                    Gestão de benefícios
                                </ToggleButton>
                            </ToggleButtonGroup>

                            {selectedPlan?.functions?.includes('benefit') && (
                                <ToggleButtonGroup
                                    fullWidth
                                    onChange={(e, value) => setFieldValue('additionals', value)}
                                    value={values.additionals}
                                    name="additionals"
                                >
                                    <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasTeleMedicina} value="telemedicina">
                                        Telemedicina
                                    </ToggleButton>
                                    <ToggleButton    sx={{ fontSize: 11 }} disabled={!hasTelePsicologia}  value="telepsicologia">
                                        Telepsicologia
                                    </ToggleButton>
                                    <ToggleButton  sx={{ fontSize: 11 }} disabled={!hasSeguro} value="seguro">
                                        Seguro de vida
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        </>
                    )}*/}
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Criando...' : 'Criar Contrato'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogSubscriptions({ mutate }) {
    const { open, handleClose } = useDialog('#subscriptions');
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const [searchValue, setSearchValue] = useState('');

    const { values, handleSubmit, setFieldValue, isSubmitting } = useFormik({
        initialValues: {
            selectedSubscription: null,
        },
        onSubmit: async (values, { setSubmitting }) => {
            if (!values.selectedSubscription) {
                enqueueSnackbar('Selecione uma assinatura.', { variant: 'warning' });
                return;
            }

            try {
                setSubmitting(true);
                await server.post(`clubs/${clubId}/signature/sync`, {
                    subscription: values.selectedSubscription,
                });
                enqueueSnackbar('Assinatura vinculada com sucesso.');
                await mutate();
                handleClose();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    const debouncedSearch = useCallback(
        debounce(searchTerm => {
            setSearchValue(searchTerm);
        }, 800),
        [],
    );

    const offset = (page - 1) * rowsPerPage;
    const { data: subscriptionsResponse } = useFetch(open && clubId ? `club/${clubId}/subscription/asaas` : null, {
        params: {
            offset,
            limit: rowsPerPage,
            search: searchValue || undefined,
        },
    });


    // Atualizar total quando receber dados
    useEffect(() => {
        if (subscriptionsResponse && Array.isArray(subscriptionsResponse)) {
            const hasMoreData = subscriptionsResponse.length >= rowsPerPage;
            const estimatedTotal = hasMoreData ? page * rowsPerPage + 1 : (page - 1) * rowsPerPage + subscriptionsResponse.length;
            setTotalCount(estimatedTotal);
        }
    }, [subscriptionsResponse, page, rowsPerPage]);

    // Handlers
    const handleSearchChange = e => {
        const value = e.target.value;
        setInputValue(value); // Atualiza input imediatamente
        setPage(1);
        setFieldValue('selectedSubscription', null);

        debouncedSearch(value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage + 1);
        setFieldValue('selectedSubscription', null);
    };

    const handleRowsPerPageChange = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
        setFieldValue('selectedSubscription', null);
    };

    const handleSubscriptionSelect = subscription => {
        setFieldValue('selectedSubscription', subscription);
    };

    // Cleanup do debounce
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    if (!open) return null;


    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Selecione a assinatura</DialogTitle>
            <Divider />

            <DialogContent>
                <form onSubmit={handleSubmit}>
                    <Stack gap={2} sx={{ mt: 2 }}>
                        <TextField
                            placeholder="Buscar pelo CNPJ..."
                            value={inputValue}
                            onChange={handleSearchChange}
                            variant="outlined"
                            fullWidth
                            helperText={inputValue && inputValue !== searchValue ? 'Buscando...' : 'Busque pelo CNPJ do cliente'}
                        />

                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell />
                                        <TableCell>Name</TableCell>
                                        {/* <TableCell>CNPJ</TableCell> */}
                                        <TableCell>Vencimento</TableCell>
                                        <TableCell>Cliente</TableCell>
                                        <TableCell>Valor</TableCell>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {subscriptionsResponse?.map(sub => (
                                        <TableRow key={sub.id} hover>
                                            <TableCell>
                                                <Checkbox
                                                    checked={values.selectedSubscription?.id === sub.id}
                                                    onChange={() => handleSubscriptionSelect(sub)}
                                                />
                                            </TableCell>
                                            <TableCell>{sub?.customer?.name}</TableCell>
                                            {/* <TableCell>{sub.customer?.cpfCnpj}</TableCell> */}
                                            <TableCell>{formatDate(sub.nextDueDate)}</TableCell>
                                            <TableCell>R$ {sub.value}</TableCell>
                                            <TableCell>{sub.id}</TableCell>

                                            <TableCell>{sub.status}</TableCell>
                                        </TableRow>
                                    ))}

                                    {(!subscriptionsResponse || subscriptionsResponse.length === 0) && (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center">
                                                {searchValue ? 'Nenhuma assinatura encontrada para este termo.' : 'Nenhuma assinatura encontrada.'}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TablePagination
                            component="div"
                            count={totalCount}
                            page={page - 1}
                            onPageChange={handlePageChange}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            labelRowsPerPage="Itens por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`}
                        />
                    </Stack>
                </form>
            </DialogContent>

            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button
                    variant="contained"
                    type="submit"
                    onClick={handleSubmit}
                    disabled={isSubmitting || !values.selectedSubscription}>
                    {isSubmitting ? 'Vinculando...' : 'Vincular assinatura'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
function FlagSwitchGroup({ label, value, onChange, options }) {
    const selected = new Set(value);
    const toggle = key => {
        const next = new Set(selected);
        if (next.has(key)) next.delete(key);
        else next.add(key);
        onChange([...next]);
    };

    return (
        <Box>
            <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>
                {label}
            </Typography>
            <Stack>
                {options.map(item => (
                    <FormControlLabel
                        key={item.value}
                        sx={{ mx: 0, justifyContent: 'space-between', ml: 0 }}
                        labelPlacement="start"
                        control={
                            <Switch
                                checked={selected.has(item.value)}
                                onChange={() => toggle(item.value)}
                            />
                        }
                        label={item.label}
                    />
                ))}
            </Stack>
        </Box>
    );
}

function DialogUpdateContract({ open, onClose, data, mutate }) {
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();

    const { values, handleSubmit, setFieldValue, setValues, isSubmitting } = useFormik({
        enableReinitialize: true,
        initialValues: {
            functions: asList(data?.functions),
            additionals: asList(data?.additionals),
            customs: asList(data?.customs),
        },
        onSubmit: async (next, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`subscription/club/${clubId}/functions`, {
                    functions: next.functions,
                    additionals: next.additionals,
                    customs: next.customs,
                });
                enqueueSnackbar('Funcionalidades atualizadas.');
                await mutate();
                onClose();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    useEffect(() => {
        if (open) {
            setValues({
                functions: asList(data?.functions),
                additionals: asList(data?.additionals),
                customs: asList(data?.customs),
            });
        }
    }, [open, data, setValues]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>Editar funcionalidades do clube</DialogTitle>
            <DialogContent dividers>
                <Stack gap={2.5}>
                    <FlagSwitchGroup
                        label="Funcionalidades"
                        value={values.functions}
                        onChange={next => setFieldValue('functions', next)}
                        options={FUNCTION_OPTIONS}
                    />
                    <FlagSwitchGroup
                        label="Adicionais"
                        value={values.additionals}
                        onChange={next => setFieldValue('additionals', next)}
                        options={ADDITIONAL_OPTIONS}
                    />
                    <FlagSwitchGroup
                        label="Customizações"
                        value={values.customs}
                        onChange={next => setFieldValue('customs', next)}
                        options={CUSTOM_OPTIONS}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isSubmitting}>Cancelar</Button>
                <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

// Componente de listagem de faturas (sem Dialog)
// export function InvoicesList({ club, data, isLoading, updateCard }) {

//     // console.log('data INVOICES : ', data);
//     const [showCardForm, setShowCardForm] = useState(false);

//     const handleDownloadInvoice = url => {
//         if (!url) return;
//         window.open(url, '_blank', 'noopener');
//     };

//     const sortedInvoices = useMemo(() => {
//         if (!data || !Array.isArray(data)) return [];

//         return [...data].sort((a, b) => {
//             const dateA = new Date(a.dueDate || 0);
//             const dateB = new Date(b.dueDate || 0);
//             return dateA - dateB;
//         });
//     }, [data]);

//     if (isLoading) {
//         return (
//             <Box sx={{ textAlign: 'center', py: 4 }}>
//                 <Typography variant="body2" color="text.secondary">
//                     Carregando faturas...
//                 </Typography>
//             </Box>
//         );
//     }

//     if (!data) return null;

//     function formatDate(date) {
//         if (!date) return '--';
//         const [year, month, day] = date.split('-');
//         const result = `${day}/${month}/${year}`;

//         return result;
//     }
//     return (
//         <Stack gap={3}>
//             {/* Header com botão estratégico */}
//             {updateCard && club?.Signature?.billingType === 'CREDIT_CARD' && (
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Typography variant="h6">Faturas</Typography>

//                     <Button variant="contained" onClick={() => setShowCardForm(prev => !prev)}>
//                         {showCardForm ? 'Fechar formulário' : 'Alterar dados do cartão'}
//                     </Button>
//                 </Box>
//             )}
//             {/* Lista de faturas normal */}
//             {sortedInvoices?.length > 0 ? (
//                 <TableContainer component={Paper}>
//                     <Table size="small">
//                         <TableHead>
//                             <TableRow>
//                                 <TableCell>ID</TableCell>
//                                 <TableCell>Valor</TableCell>
//                                 <TableCell>Vencimento</TableCell>
//                                 <TableCell>Status</TableCell>
//                                 <TableCell>Pagamento</TableCell>
//                                 <TableCell>Descrição</TableCell>
//                                 <TableCell align="right">Ações</TableCell>
//                             </TableRow>
//                         </TableHead>

//                         <TableBody>
//                             {sortedInvoices.map(invoice => (
//                                 <TableRow key={invoice?.id} hover>
//                                     <TableCell>
//                                         <Typography variant="body2" fontWeight="medium">
//                                             #{invoice?.id}
//                                         </Typography>
//                                     </TableCell>

//                                     <TableCell>
//                                         <Typography variant="body2" fontWeight="medium">
//                                             R${' '}
//                                             {parseFloat(invoice?.value || 0)
//                                                 .toFixed(2)
//                                                 .replace('.', ',')}
//                                         </Typography>
//                                     </TableCell>

//                                     <TableCell>
//                                         <Typography variant="body2">{invoice?.dueDate ? formatDate(invoice?.dueDate) : '--'}</Typography>
//                                     </TableCell>

//                                     <TableCell>
//                                         <Chip
//                                             label={statuses[invoice?.status]?.label || invoice?.status || 'Processando'}
//                                             color={statuses[invoice?.status]?.color || 'default'}
//                                             size="small"
//                                         />
//                                     </TableCell>

//                                     <TableCell>
//                                         {invoice?.paymentDate ? (
//                                             <Typography variant="body2">{formatDate(invoice?.paymentDate || invoice?.confirmedDate)}</Typography>
//                                         ) : (
//                                             <Typography variant="body2" color="text.secondary">
//                                                 {formatDate(invoice?.confirmedDate)}
//                                             </Typography>
//                                         )}
//                                     </TableCell>

//                                     <TableCell>
//                                         <Typography variant="body2" color="text.secondary">
//                                             {invoice?.description || '--'}
//                                         </Typography>
//                                     </TableCell>

//                                     <TableCell align="right">
//                                         {/* Se estiver pendente, botão com ícone abrindo o invoiceUrl */}
//                                         {['PENDING', 'OVERDUE'].includes(invoice?.status) && invoice?.invoiceUrl ? (
//                                             <IconButton
//                                                 size="small"
//                                                 onClick={() => window.open(invoice?.invoiceUrl, '_blank', 'noopener')}
//                                                 title="Abrir boleto"
//                                             >
//                                                 <OpenInNew fontSize="small" />
//                                             </IconButton>
//                                         ) : invoice?.bankSlipUrl && !['CONFIRMED', 'RECEIVED'].includes(invoice?.status) ? (
//                                             <IconButton
//                                                 size="small"
//                                                 onClick={() => handleDownloadInvoice(invoice?.bankSlipUrl)}
//                                                 title="Baixar boleto"
//                                             >
//                                                 <Download fontSize="small" />
//                                             </IconButton>
//                                         ) : (
//                                             <Typography variant="body2" color="text.secondary">
//                                                 <IconButton
//                                                     title="Baixar comprovante"
//                                                     size="small"
//                                                     onClick={() => handleDownloadInvoice(invoice?.transactionReceiptUrl)}
//                                                 >
//                                                     <Download fontSize="small" />
//                                                 </IconButton>
//                                             </Typography>
//                                         )}
//                                     </TableCell>
//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             ) : (
//                 <Box sx={{ textAlign: 'center', py: 4 }}>
//                     <Typography variant="body1" color="text.secondary">
//                         Nenhuma fatura encontrada
//                     </Typography>
//                 </Box>
//             )}
//             {/* Form logo abaixo quando aberto */}
//             {showCardForm && (
//                 <Card sx={{ mb: 2 }}>
//                     <CardContent>
//                         <CardUpdateForm setShowCardForm={setShowCardForm} club={club?.id} onSuccess={() => setShowCardForm(false)} />
//                     </CardContent>
//                 </Card>
//             )}
//         </Stack>
//     );
// }

// function CardUpdateForm({ clubId, onSuccess, setShowCardForm }) {
//     const { enqueueSnackbar, setErrors } = useErrors();
//     const confirm = useConfirm();

//     const { values, getFieldProps, handleSubmit, isSubmitting, errors, touched } = useFormik({
//         initialValues: {
//             holderName: '',
//             cardNumber: '',
//             expiryMonth: '',
//             expiryYear: '',
//             ccv: '',
//             cpfCnpj: '',
//             email: '',
//             postalCode: '',
//             addressNumber: '',
//             phone: '',
//         },
//         validate: formValues => {
//             const requiredFields = [
//                 'holderName',
//                 'cardNumber',
//                 'expiryMonth',
//                 'expiryYear',
//                 'ccv',
//                 'cpfCnpj',
//                 'email',
//                 'postalCode',
//                 'addressNumber',
//                 'phone',
//             ];
//             const validationErrors = {};
//             requiredFields.forEach(field => {
//                 if (!formValues[field]) {
//                     validationErrors[field] = 'Campo obrigatório';
//                 }
//             });
//             return validationErrors;
//         },
//         onSubmit: async (formValues, helpers) => {
//             try {
//                 helpers.setSubmitting(true);
//                 await confirm({
//                     title: 'Atualizar dados do cartão',
//                     description: 'Tem certeza que deseja atualizar os dados do cartão?',
//                 });
//                 const { data } = await server.put(`club/payment/asaas/subscriptions/card`, formValues);
//                 enqueueSnackbar('Dados do cartão atualizados com sucesso.');
//                 helpers.setSubmitting(false);
//                 setShowCardForm(false);
//                 console.log(data);
//             } catch (error) {
//                 setErrors(error);
//             } finally {
//                 helpers.setSubmitting(false);
//             }
//         },
//     });

//     return (
//         <form onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
//                 <CardHeader title="Alterar dados do cartão" subheader="Atualize as informações do cartão da assinatura quando necessário." />

//                 <Grid item xs={12} md={6}>
//                     <TextField
//                         label="Nome no cartão"
//                         {...getFieldProps('holderName')}
//                         fullWidth
//                         error={touched.holderName && Boolean(errors.holderName)}
//                         helperText={touched.holderName && errors.holderName}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                     <TextField
//                         label="Número do cartão"
//                         {...getFieldProps('cardNumber')}
//                         fullWidth
//                         error={touched.cardNumber && Boolean(errors.cardNumber)}
//                         helperText={touched.cardNumber && errors.cardNumber}
//                     />
//                 </Grid>
//                 <Grid item xs={6} md={3}>
//                     <TextField
//                         label="Mês"
//                         {...getFieldProps('expiryMonth')}
//                         fullWidth
//                         error={touched.expiryMonth && Boolean(errors.expiryMonth)}
//                         helperText={touched.expiryMonth && errors.expiryMonth}
//                     />
//                 </Grid>
//                 <Grid item xs={6} md={3}>
//                     <TextField
//                         label="Ano"
//                         {...getFieldProps('expiryYear')}
//                         fullWidth
//                         error={touched.expiryYear && Boolean(errors.expiryYear)}
//                         helperText={touched.expiryYear && errors.expiryYear}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                     <TextField
//                         label="CVV"
//                         {...getFieldProps('ccv')}
//                         fullWidth
//                         error={touched.ccv && Boolean(errors.ccv)}
//                         helperText={touched.ccv && errors.ccv}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                     <TextField
//                         label="CPF/CNPJ"
//                         {...getFieldProps('cpfCnpj')}
//                         fullWidth
//                         error={touched.cpfCnpj && Boolean(errors.cpfCnpj)}
//                         helperText={touched.cpfCnpj && errors.cpfCnpj}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                     <TextField
//                         label="E-mail"
//                         {...getFieldProps('email')}
//                         fullWidth
//                         error={touched.email && Boolean(errors.email)}
//                         helperText={touched.email && errors.email}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                     <TextField
//                         label="CEP"
//                         {...getFieldProps('postalCode')}
//                         fullWidth
//                         error={touched.postalCode && Boolean(errors.postalCode)}
//                         helperText={touched.postalCode && errors.postalCode}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                     <TextField
//                         label="Número"
//                         {...getFieldProps('addressNumber')}
//                         fullWidth
//                         error={touched.addressNumber && Boolean(errors.addressNumber)}
//                         helperText={touched.addressNumber && errors.addressNumber}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                     <TextField
//                         label="Telefone"
//                         {...getFieldProps('phone')}
//                         fullWidth
//                         error={touched.phone && Boolean(errors.phone)}
//                         helperText={touched.phone && errors.phone}
//                     />
//                 </Grid>
//             </Grid>
//             <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ mt: 3 }}>
//                 <Button type="submit" variant="contained" disabled={isSubmitting}>
//                     {isSubmitting ? 'Preparando...' : 'Salvar alterações'}
//                 </Button>
//             </Stack>
//         </form>
//     );
// }

// Dialog wrapper para manter compatibilidade
// export function DialogInvoices({ club }) {
//     const { open, handleClose } = useDialog('#invoices');
//     const { enqueueSnackbar, setErrors } = useErrors();
//     const { data: invoicesData, isLoading } = useFetch(
//         club?.id ? `clubs/${club.id}/invoices/asaas` : null
//     );

//     const [subscriptionDueDate, setSubscriptionDueDate] = useState('');
//     const [sendingDueDate, setSendingDueDate] = useState(false);



//     if (!open) return null;

//     // Separar invoices da assinatura, Orders e cobranças customizadas
//     // Compatibilidade com formato antigo (apenas array) e novo (objeto com subscription, orders e customCharges)
//     const subscriptionInvoices =
//         invoicesData?.subscription || (Array.isArray(invoicesData?.data) ? invoicesData.data : []);
//     const orderCharges = invoicesData?.orders || [];
//     const customCharges = invoicesData?.customCharges || [];

//     const handleUpdateSubscriptionDueDate = async () => {
//         if (!subscriptionDueDate || !club?.id) return;
//         try {
//             setSendingDueDate(true);
//             const { data } = await server.put(`clubs/${club.id}/subscription/due-date`, { dueDate: subscriptionDueDate });
//             enqueueSnackbar(`Data de vencimento recebida no back: ${data?.dueDate ?? subscriptionDueDate}`);
//         } catch (error) {
//             setErrors(error);
//         } finally {
//             setSendingDueDate(false);
//         }
//     };

//     const hasCustomPayment =  customCharges.length > 0;



//     return (
//         <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">
//             <DialogTitle>Histórico de Faturas</DialogTitle>
//             <Divider />
//             <DialogContent>
//                 <Stack gap={3}>
//                     {/* Cobranças da Assinatura */}
//                     <Paper variant="outlined" sx={{ p: 2, borderColor: 'divider' }}>
//                         <Typography variant="h6" sx={{ mb: 2 }}>
//                             Cobranças da Assinatura
//                         </Typography>
//                         <Stack direction="row" alignItems="center" gap={2} sx={{ mb: 2 }} flexWrap="wrap">
//                             <TextField
//                                 label="Data de vencimento da assinatura"
//                                 type="date"
//                                 value={subscriptionDueDate}
//                                 onChange={(e) => setSubscriptionDueDate(e.target.value)}
//                                 InputLabelProps={{ shrink: true }}
//                                 size="small"
//                                 sx={{ minWidth: 220 }}
//                             />
//                             <Button
//                                 variant="outlined"
//                                 onClick={handleUpdateSubscriptionDueDate}
//                                 disabled={!subscriptionDueDate || sendingDueDate}
//                             >
//                                 {sendingDueDate ? 'Enviando...' : 'Alterar vencimento'}
//                             </Button>
//                         </Stack>
//                         {subscriptionInvoices.length > 0 ? (
//                             <InvoicesList
//                                 club={club}
//                                 updateCard={false}
//                                 data={subscriptionInvoices}
//                                 isLoading={isLoading}
//                             />
//                         ) : (
//                             <Box sx={{ textAlign: 'center', py: 2 }}>
//                                 <Typography variant="body2" color="text.secondary">
//                                     Nenhuma cobrança da assinatura encontrada
//                                 </Typography>
//                             </Box>
//                         )}
//                     </Paper>

//                     {/* Cobranças Customizadas (Custom Products) */}
//                     {hasCustomPayment && customCharges && (
//                         <Paper variant="outlined" sx={{ p: 2, borderColor: 'divider' }}>

//                             <Typography variant="h6" sx={{ mb: 2 }}>
//                                 Cobranças de Customização
//                             </Typography>
//                             <InvoicesList
//                                 club={club}
//                                 updateCard={false}
//                                 data={customCharges}
//                                 isLoading={isLoading}
//                             />


//                         </Paper>
//                     )}

//                     {/* Cobranças das Orders */}
//                     {orderCharges.length > 0 && (
//                         <Paper variant="outlined" sx={{ p: 2, borderColor: 'divider' }}>
//                             <Typography variant="h6" sx={{ mb: 2 }}>
//                                 Cobranças de Benefícios
//                             </Typography>
//                             {orderCharges.length > 0 ? (
//                                 <InvoicesList
//                                     club={club}
//                                     updateCard={false}
//                                     data={orderCharges}
//                                     isLoading={isLoading}
//                                 />
//                             ) : (
//                                 <Box sx={{ textAlign: 'center', py: 2 }}>
//                                     <Typography variant="body2" color="text.secondary">
//                                         Nenhuma cobrança encontrada
//                                     </Typography>
//                                 </Box>
//                             )}
//                         </Paper>
//                     )}

//                 </Stack>

//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={handleClose}>Fechar</Button>
//             </DialogActions>
//         </Dialog>
//     );
// }

function DialogSignature({ data, mutate }) {
    const { open, handleClose } = useDialog('#signature');
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();

    const { values, handleSubmit, setFieldValue, setValues, isSubmitting } = useFormik({
        initialValues: {
            status: 'WAITING',
            cycle: 'MONTHLY',
            billingType: '',
            dueDateCycle: null,
            lastPaymentAt: null,
        },
        onSubmit: async (formValues, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`clubs/${clubId}/signature`, {
                    status: formValues.status || null,
                    cycle: formValues.cycle || null,
                    billingType: formValues.billingType || null,
                    dueDateCycle: toIsoDate(formValues.dueDateCycle) || null,
                    lastPaymentAt: toIsoDate(formValues.lastPaymentAt) || null,
                });
                enqueueSnackbar('Assinatura atualizada.');
                await mutate();
                handleClose();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    useEffect(() => {
        if (!open) return;
        const signature = data?.Signature;
        setValues({
            status: signature?.status || 'WAITING',
            cycle: signature?.cycle || 'MONTHLY',
            billingType: signature?.billingType || signature?.paymentData?.billingType || '',
            dueDateCycle: toPickerDate(signature?.dueDateCycle),
            lastPaymentAt: toPickerDate(signature?.lastPaymentAt),
        });
    }, [open, data, setValues]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Editar assinatura</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2} sx={{ mt: 1 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="signature-status-label">Status</InputLabel>
                        <Select
                            labelId="signature-status-label"
                            label="Status"
                            value={values.status}
                            onChange={e => setFieldValue('status', e.target.value)}
                        >
                            {Object.entries(SIGNATURE_STATUS_META)
                                .filter(([key]) => key !== 'CANCELED')
                                .map(([key, meta]) => (
                                    <MenuItem key={key} value={key}>
                                        {meta.label}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel id="signature-cycle-label">Ciclo</InputLabel>
                        <Select
                            labelId="signature-cycle-label"
                            label="Ciclo"
                            value={values.cycle}
                            onChange={e => setFieldValue('cycle', e.target.value)}
                        >
                            {Object.entries(CYCLE_LABELS).map(([key, label]) => (
                                <MenuItem key={key} value={key}>
                                    {label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel id="signature-billing-label">Forma de pagamento</InputLabel>
                        <Select
                            labelId="signature-billing-label"
                            label="Forma de pagamento"
                            value={values.billingType}
                            onChange={e => setFieldValue('billingType', e.target.value)}
                        >
                            <MenuItem value="">Não informado</MenuItem>
                            <MenuItem value="BOLETO">Boleto</MenuItem>
                            <MenuItem value="CREDIT_CARD">Cartão de crédito</MenuItem>
                            <MenuItem value="PIX">PIX</MenuItem>
                            <MenuItem value="DEBIT_CARD">Cartão de débito</MenuItem>
                            <MenuItem value="UNDEFINED">Indefinido</MenuItem>
                        </Select>
                    </FormControl>
                    <DatePicker
                        label="Vencimento"
                        value={values.dueDateCycle}
                        onChange={value => setFieldValue('dueDateCycle', value)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                    />
                    <DatePicker
                        label="Último pagamento"
                        value={values.lastPaymentAt}
                        onChange={value => setFieldValue('lastPaymentAt', value)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                    />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogStatus({ data, mutate }) {
    const { open, handleClose } = useDialog('#status');
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();

    const { values, handleSubmit, setValues, isSubmitting } = useFormik({
        initialValues: {
            status: false,
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`clubs/${clubId}`, { status: values.status });
                enqueueSnackbar(`Status do clube alterado com sucesso.`);
                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            setValues({ status: data?.status });
        }
    }, [data]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Alterar Status do Clube</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    <FormControlLabel
                        control={<Switch checked={values.status} onChange={e => setValues({ status: e.target.checked })} />}
                        label={values.status ? 'Ativo' : 'Inativo'}
                    />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default function ContractClub({ data, mutate }) {
    const { user } = useAuth();
    const isSuper = Boolean(user?.super);
    const [editFlagsOpen, setEditFlagsOpen] = useState(false);
    // const { id: clubId } = useParams();
    // const { data: invoice, isLoading } = useFetch(`clubs/${clubId}`);

    const { club: invoice, isLoading, hasCustomApp, hasMultiApp, hasCoupons, hasVouchers, hasCashback, hasBenefits, isReseller } = useClub();
    if (isLoading) return <></>;

    // Função para formatar data
    const formatDate = date => {
        if (!date) return '--';
        return new Date(date).toLocaleDateString('pt-BR');
    };

    // Função para verificar se a assinatura está vencida
    const isSubscriptionExpired = dueDate => {
        if (!dueDate) return false;
        return new Date(dueDate) < new Date();
    };

    const getSubscriptionStatus = () => {
        const subscription = data?.Signature;
        if (!subscription) return { label: 'Sem assinatura', color: 'default', icon: PauseCircle };

        const fromStatus = SIGNATURE_STATUS_META[subscription.status];
        if (fromStatus) return fromStatus;

        const isExpired = isSubscriptionExpired(subscription.dueDateCycle);
        if (['ACTIVE', 'CONFIRMED', 'RECEIVED'].includes(subscription.paymentStatus) && !isExpired) {
            return SIGNATURE_STATUS_META.ACTIVE;
        }
        if (isExpired || subscription.paymentStatus === 'OVERDUE') {
            return SIGNATURE_STATUS_META.EXPIRED;
        }
        if (['PENDING', 'WAITING'].includes(subscription.paymentStatus)) {
            return SIGNATURE_STATUS_META.WAITING;
        }
        return { label: subscription.status || 'Inativa', color: 'default', icon: PauseCircle };
    };

    const subscriptionStatus = getSubscriptionStatus();
    const SubscriptionStatusIcon = subscriptionStatus.icon;


    return (
        <Stack spacing={2}>
                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1} sx={{ mb: 2 }}>
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <Business color="primary" />
                                    <Typography variant="h6">Plano</Typography>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                    {isSuper && (
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            startIcon={<Edit />}
                                            onClick={() => setEditFlagsOpen(true)}
                                        >
                                            Editar
                                        </Button>
                                    )}
                                    {!data?.Signature?.subscriptionId && (
                                        <Button
                                            component="a"
                                            href="#subscriptions"
                                            variant="outlined"
                                            size="small"
                                            startIcon={<Sync />}
                                        >
                                            Sincronizar assinatura
                                        </Button>
                                    )}
                                </Stack>
                            </Stack>

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                                    gap: 2,
                                }}
                            >
                                <Box minWidth={0}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Plano
                                    </Typography>
                                    <Typography variant="body2" fontWeight={700} noWrap>
                                        {data?.Signature?.planData?.name || data?.Signature?.Plan?.name || data?.Contract?.plan?.name || '--'}
                                    </Typography>
                                </Box>
                                <Box minWidth={0}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Valor
                                    </Typography>
                                    <Typography variant="body2" fontWeight={700} noWrap>
                                        R$ {data?.Signature?.value?.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) || 'Free'}
                                    </Typography>
                                </Box>
                                <Box minWidth={0}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Funcionalidades
                                    </Typography>
                                    <ChipList items={asList(data?.functions)} labels={FUNCTION_LABELS} empty="Nenhuma" />
                                </Box>
                                <Box minWidth={0}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Adicionais
                                    </Typography>
                                    <ChipList items={asList(data?.additionals)} labels={ADDITIONAL_LABELS} empty="Nenhum" />
                                </Box>
                                <Box minWidth={0} sx={{ gridColumn: { xs: '1', sm: '1 / -1' } }}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Customizações
                                    </Typography>
                                    <ChipList items={asList(data?.customs)} labels={CUSTOM_LABELS} empty="Nenhuma" />
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>

                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1} sx={{ mb: 2 }}>
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <Payment color="primary" />
                                    <Typography variant="h6">Assinatura</Typography>
                                </Stack>
                                <Button component="a" href="#signature" size="small" startIcon={<Edit />}>
                                    Editar
                                </Button>
                            </Stack>

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(5, minmax(0, 1fr))' },
                                    gap: 2,
                                }}
                            >
                                <Box minWidth={0}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Status
                                    </Typography>
                                    <Chip
                                        icon={SubscriptionStatusIcon ? <SubscriptionStatusIcon /> : undefined}
                                        label={subscriptionStatus.label}
                                        color={subscriptionStatus.color}
                                        size="small"
                                    />
                                </Box>
                                <Box minWidth={0}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Ciclo
                                    </Typography>
                                    <Typography variant="body2" fontWeight={700} noWrap>
                                        {CYCLE_LABELS[data?.Signature?.cycle] || data?.Signature?.cycle || '--'}
                                    </Typography>
                                </Box>
                                <Box minWidth={0}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Vencimento
                                    </Typography>
                                    <Typography variant="body2" fontWeight={700} noWrap>
                                        {formatDate(data?.Signature?.dueDateCycle)}
                                    </Typography>
                                </Box>
                                <Box minWidth={0}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Pagamento
                                    </Typography>
                                    <Typography variant="body2" fontWeight={700} noWrap>
                                        {payments[
                                            data?.Signature?.billingType?.toLowerCase() ||
                                            data?.Signature?.paymentData?.billingType?.toLowerCase()
                                        ] || '--'}
                                    </Typography>
                                </Box>
                                <Box minWidth={0}>
                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                                        Último pagamento
                                    </Typography>
                                    <Typography variant="body2" fontWeight={700} noWrap>
                                        {formatDate(data?.Signature?.lastPaymentAt)}
                                    </Typography>
                                </Box>
                            </Box>
                        </CardContent>
                        <Divider />
                        <CardActions sx={{ justifyContent: 'flex-end' }}>
                            <Button component="a" href="#invoices" variant="outlined">
                                Detalhes de pagamento
                            </Button>
                        </CardActions>
                    </Card>

                {/* <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
                                <Business color="primary" />
                                <Typography variant="h6">Status do Clube</Typography>
                            </Stack>

                            <Stack spacing={2}>
                                <Box>
                                    <Typography variant="body2" color="text.secondary">
                                        Status
                                    </Typography>
                                    <Chip
                                        label={data?.status ? 'Ativo' : 'Inativo'}
                                        color={data?.status ? 'success' : 'default'}
                                        size="small"
                                    />
                                </Box>


                                <Box sx={{ mt: 2 }}>

                                </Box>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <Button component="a" href="#status" variant="outlined"   >
                                Alterar Status
                            </Button>
                        </CardActions>
                    </Card>
                </Grid> */}
            <DialogSale mutate={mutate} />
            <DialogCreateContract data={data} mutate={mutate} />
            <DialogUpdateContract
                open={editFlagsOpen}
                onClose={() => setEditFlagsOpen(false)}
                data={data}
                mutate={mutate}
            />
            <DialogSubscriptions data={data} mutate={mutate} />
            <DialogSignature data={data} mutate={mutate} />

            <DialogInvoices club={data} mutateClub={mutate} />
            <DialogStatus data={data} mutate={mutate} />
        </Stack>
    );
}
